import styles from "./styles.module.css";
import { ReactNode } from "react";

export default function PageWrapper({ children }: { children: ReactNode }) {
  return <div className={styles.pageWrapperRoot}>{children}</div>;
}
